/// <summary>
/// 游戏界面生命周期统计相关
/// </summary>
import KitAPI from "../KitAPI";
import {KitSp} from "../KitSp";
import {KitEvent} from "./KitEvent";
import {KitBehaviour} from "@/Fwk/Kit/KitBehaviour";
import {KitTrack} from "@/Fwk/Kit/Track/KitTrack";
import {GameLifecycle, IGameLifecycle} from "@/Fwk/Kit/GameLifecycle";
import {EventName, RecodeKey} from "@/Fwk/Kit/Track/TrackConst";

/// <author>xiexingwu</author>
export class TrackLifecycle implements IGameLifecycle {
    private static TRACK_LAST_PAUSED_TIME = "track_last_paused_time";
    private static TRACK_APPTIMER_TIMES = "track_apptimer_times";
    private static lastResumedTime: number = 0;

    private static get lastPausedTime(): number {
        return KitSp.GetInt(this.TRACK_LAST_PAUSED_TIME, 0)
    }

    private static set lastPausedTime(v: number) {
        KitSp.SetInt(this.TRACK_LAST_PAUSED_TIME, v);
        KitSp.Apply();
    }

    private static get timerEventTimes(): number {
        return KitSp.GetInt(this.TRACK_APPTIMER_TIMES, 0);
    }
    
    private static set timerEventTimes(v: number) {
        KitSp.SetInt(this.TRACK_APPTIMER_TIMES, v);
        KitSp.Apply();
    }


    static Init() {
        const gameLifecycle = new TrackLifecycle();
        GameLifecycle.set(gameLifecycle);
    }

    private TrackLifecycle() {
    }

    private TrackAppTimer() {
        const now = KitAPI.GetNowMills();
        const seconds = now - TrackLifecycle.lastResumedTime;
        KitEvent.track511(EventName.APP_TIMER).Put(RecodeKey.EVENT_DURATION, seconds).Commit();
        TrackLifecycle.timerEventTimes = TrackLifecycle.timerEventTimes + 1;
        TrackLifecycle.lastResumedTime = now;
    }

    private RunPre5seconds() {
        const maxTimes = 10;
        if (TrackLifecycle.timerEventTimes >= maxTimes) return;
        const time = maxTimes - TrackLifecycle.timerEventTimes;
        //前面10次统计，每5秒统计1次
        KitBehaviour._timer.SetTimer("TrackLifecycle", () => {
            if (TrackLifecycle.timerEventTimes <= maxTimes) {
                this.TrackAppTimer();
            }
        }, 5, time);
    }

    public onGameCreated() {
        KitEvent.track511(EventName.APP_CREATE).Commit();
        this.RunPre5seconds();
    }

    public onGameResumed() {
        const now = KitAPI.GetNowMills();
        TrackLifecycle.lastResumedTime = now;

        KitEvent.track511(EventName.APP_SHOW).Commit();
        //获取上次进入后台的时间

        if (Math.abs(now - TrackLifecycle.lastPausedTime) > 30 * 1000) {
            //曾经退居后台30秒以上
            KitEvent.track511(EventName.APP_RESUME).Commit();
        }

        if (Math.abs(now - TrackLifecycle.lastPausedTime) > 60 * 60 * 1000) //1小时
        {
            //曾经退居后台1小时以上
            KitTrack.TrackALive(EventName.ALIVE_RESUME);
        }
    }

    public onGamePaused() {
        //记录进入后台时间
        TrackLifecycle.lastPausedTime = KitAPI.GetNowMills();
        //统计在前台的时间
        this.TrackAppTimer();
    }
}
